var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('div',{staticClass:"alert-body text-center"},[_c('FeatherIcon',{attrs:{"icon":"InfoIcon","size":"24"}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }